// --- Troca estes imports pelos teus assets reais ---
import logo from "./media/frescuradasbeiras_logo.png";
import heroImage from "./media/landingpicture.webp";
import { FaFacebookF } from "react-icons/fa";

import gala from './media/gala.webp'
import fuji from './media/fuji.jpg'
import golden from './media/golden.jpg'
import granny from './media/granny.jpg'

import sede from './media/sede.webp'
import nelas from './media/nelas.webp'
import sustainability800 from './media/sustainability-800.webp'
import { useEffect, useState } from "react";

// ---------------------------------------------------

type Product = {
  id: string;
  name: string;
  subtitle: string;
  badge?: string;
  imageSrc: string;
};

const stores: Store[] = [
  {
    city: "Viseu",
    address: "Estrada Municipal, São João de Lourosa, Viseu",
    hours: "Seg–Sáb • 09:00–19:00",
    phone: "+351 232 461 245",
    mapUrl: "https://www.google.com/maps/place/Frescura+das+Beiras,+Lda+-+Sede/@40.611603,-7.9209391,661m/data=!3m1!1e3!4m14!1m7!3m6!1s0xd2337295120fbc1:0x7fc66d9f5a668ce9!2sFrescura+das+Beiras,+Lda+-+Sede!8m2!3d40.611603!4d-7.9209391!16s%2Fg%2F11hbkpj1fh!3m5!1s0xd2337295120fbc1:0x7fc66d9f5a668ce9!8m2!3d40.611603!4d-7.9209391!16s%2Fg%2F11hbkpj1fh?hl=pt-PT&entry=ttu",
    imageSrc: sede,
  },
  {
    city: "Nelas",
    address: "R. Alexandre Herculano 215, Nelas",
    hours: "Seg–Sáb • 09:00–19:00",
    phone: "+351 232 461 245",
    mapUrl: "https://www.google.com/maps?hl=pt-PT&gl=pt&um=1&ie=UTF-8&fb=1&sa=X&ftid=0xd23378791b192d3:0xb14656fd1d199581",
    imageSrc: nelas,
  },
];

type Store = {
  city: string;
  address: string;
  hours: string;
  phone?: string;
  mapUrl: string;
  imageSrc: string;
};


const PRODUCTS: Product[] = [
  {
    id: "gala",
    name: "Gala",
    subtitle: "",
    badge: "",
    imageSrc: gala,
  },
  {
    id: "fuji",
    name: "Fuji",
    subtitle: "",
    imageSrc: fuji,
  },
  {
    id: "golden",
    name: "Golden",
    subtitle: "",
    badge: "",
    imageSrc: golden,
  },
  {
    id: "granny",
    name: "Granny",
    subtitle: "",
    badge: "",
    imageSrc: granny,
  },
];

function cx(...classes: Array<string | false | undefined | null>) {
  return classes.filter(Boolean).join(" ");
}

export default function App() {
  return (
    <div className="min-h-screen bg-[#08110b] text-white">
      <TopNav logo={logo} />
      <main>
        <Hero />
        <Heritage />
        <Promise />
        <FeaturedHarvest />
        <StoresSection stores={stores} />
        {/* <Newsletter /> */}
      </main>
      <Footer />
    </div>
  );
}

function TopNav({ logo }: { logo: string }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const close = () => setOpen(false);

  return (
    <header
      className={[
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300",
        scrolled
          ? "bg-black/90 backdrop-blur border-b border-white/5"
          : "bg-transparent border-b border-transparent",
      ].join(" ")}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-5">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <img
            alt="Frescura das Beiras — Logótipo"
            className="h-12 w-12"
            src={logo}
            width={48}
            height={48}
            decoding="async"
          />        </div>

        {/* Desktop nav */}
        <nav
          className={[
            "hidden md:flex items-center gap-8 text-[13px] tracking-[0.25em] uppercase",
            scrolled ? "text-white/80" : "text-white/90",
          ].join(" ")}
        >
          <a
            className={[
              "hover:opacity-80 transition",
              scrolled ? "text-[#c6a86a]" : "text-white",
            ].join(" ")}
            href="#sustentabilidade"
          >
            Sustentabilidade
          </a>

          <a
            className={[
              "hover:opacity-80 transition",
              scrolled ? "text-[#c6a86a]" : "text-white",
            ].join(" ")}
            href="#sobrenos"
          >
            Quem Somos
          </a>

          <a
            className={[
              "hover:opacity-80 transition",
              scrolled ? "text-[#c6a86a]" : "text-white",
            ].join(" ")}
            href="#contactos"
          >
            Contactos
          </a>

          {/* Facebook */}
          <a
            href="https://www.facebook.com/FrescuraBeiras"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
            className={[
              "ml-4 flex h-9 w-9 items-center justify-center rounded-full border transition",
              scrolled
                ? "border-[#c6a86a] text-[#c6a86a] hover:bg-[#c6a86a] hover:text-black"
                : "border-white/60 text-white hover:bg-white hover:text-black",
            ].join(" ")}
          >
            {FaFacebookF({ className: "text-sm" })}

          </a>
        </nav>

        {/* Mobile menu button */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={[
            "lg:hidden inline-flex items-center justify-center px-3 py-2 ring-1 transition",
            scrolled
              ? "bg-white/5 text-white ring-white/10"
              : "bg-white/10 text-white ring-white/20",
          ].join(" ")}
          aria-label="Open menu"
        >
          <div className="space-y-1.5">
            <div className="h-0.5 w-6 bg-current" />
            <div className="h-0.5 w-6 bg-current" />
            <div className="h-0.5 w-6 bg-current" />
          </div>
        </button>
      </div>

      {/* Mobile dropdown */}
      <div
        className={[
          "lg:hidden overflow-hidden transition-[max-height] duration-300",
          open ? "max-h-64" : "max-h-0",
          scrolled ? "bg-black/90 backdrop-blur" : "bg-black/40 backdrop-blur",
        ].join(" ")}
      >
        <div className="mx-auto max-w-[1400px] px-6 pb-4">
          <a
            onClick={close}
            className={[
              "block rounded-xl px-3 py-3 text-base font-medium hover:bg-white/5 transition",
              scrolled ? "text-[#c6a86a]" : "text-white",
            ].join(" ")}
            href="#sustentabilidade"
          >
            Sustentabilidade
          </a>
          <a
            onClick={close}
            className={[
              "block rounded-xl px-3 py-3 text-base font-medium hover:bg-white/5 transition",
              scrolled ? "text-[#c6a86a]" : "text-white",
            ].join(" ")}
            href="#sobrenos"
          >
            Quem Somos
          </a>
          <a
            onClick={close}
            className={[
              "block rounded-xl px-3 py-3 text-base font-medium hover:bg-white/5 transition",
              scrolled ? "text-[#c6a86a]" : "text-white",
            ].join(" ")}
            href="#contactos"
          >
            Contactos
          </a>

          <div className="mt-4 flex justify-center">
            <a
              href="https://www.facebook.com/FrescuraBeiras"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              className={[
                "flex h-10 w-10 items-center justify-center rounded-full border transition",
                scrolled
                  ? "border-[#c6a86a] text-[#c6a86a] hover:bg-[#c6a86a] hover:text-black"
                  : "border-white/70 text-white hover:bg-white hover:text-black",
              ].join(" ")}
            >
              {FaFacebookF({ className: "text-sm" })}

            </a>
          </div>
        </div>
      </div>
    </header>
  );
}


function Hero() {
  return (
    <section id="home" className="relative">
      <div className="relative h-[560px] md:h-[680px] overflow-hidden">
        <img
          src={heroImage}
          alt="Cesto de fruta fresca das Beiras"
          className="absolute inset-0 h-full w-full object-cover scale-[1.02]"
          loading="eager"
          fetchPriority="high"
          decoding="async"
        />

        {/* Camadas para “luxury depth” */}
        <div className="absolute inset-0 bg-black/35" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/25 to-[#08110b]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(198,168,106,0.18),rgba(0,0,0,0)_55%)]" />
        <div className="absolute inset-0 [box-shadow:inset_0_0_180px_rgba(0,0,0,0.75)]" />

        <div className="relative mx-auto max-w-6xl px-5 h-full flex flex-col justify-center">


          {/* Título com hierarquia */}
          <h1 className="mt-4 leading-[1.02]">
            <span className="block text-4xl md:text-6xl font-light">
              Frescura das Beiras
            </span>

          </h1>

          {/* Linha dourada */}
          <div className="mt-6 h-px w-24 bg-[#c6a86a]/90" />

          <p className="mt-5 max-w-xl text-sm md:text-[15px] text-white/80 leading-relaxed">
            Da quinta para a sua mesa, com foco em qualidade, origem conhecida e práticas
            sustentáveis.
          </p>

          {/* CTAs */}
          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#seasonal"
              className="inline-flex items-center justify-center px-6 h-11 rounded-sm
                         bg-[#c6a86a] text-[#08110b] text-[11px] tracking-[0.25em] uppercase font-semibold
                         hover:brightness-110 transition"
            >
              Explorar colheita
            </a>
            <a
              href="#lojas"
              className="inline-flex items-center justify-center px-6 h-11 rounded-sm
                         border border-white/20 text-[11px] tracking-[0.25em] uppercase font-semibold
                         hover:bg-white/5 transition"
            >
              Ver lojas
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}


function Promise() {
  return (
    <section className="bg-[#08110b]" id="sustentabilidade">
      <div className="mx-auto max-w-6xl px-5 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-stretch">
          <div className="md:col-span-4">
            <p className="text-[10px] tracking-[0.35em] uppercase text-white/60">
              O nosso compromisso
            </p>

            <h2 className="mt-3 text-3xl md:text-4xl font-light leading-tight">
              Sustentabilidade
            </h2>

            <div className="mt-5 h-px w-20 bg-[#c6a86a]/80" />

            <p className="mt-5 text-sm text-white/65 leading-relaxed">
              Trabalhamos para produzir melhor com menos impacto: reduzimos
              desperdícios, cuidamos da água e melhoramos continuamente as
              práticas no campo e na operação.
            </p>
          </div>

          <div className="md:col-span-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <PromiseCard
              title="MENOS DESPERDÍCIO"
              text="Planeamento de colheita e seleção cuidadosa para aproveitar cada fruto e reduzir perdas."
            />
            <PromiseCard
              title="ÁGUA COM CONSCIÊNCIA"
              text="Rega otimizada e monitorização para usar apenas o necessário, respeitando o ciclo natural."
            />
            <PromiseCard
              title="EMBALAGEM RESPONSÁVEL"
              text="Soluções mais leves e recicláveis, com foco em proteger a fruta e diminuir a pegada ambiental."
            />
          </div>
        </div>
      </div>
    </section>
  );
}


function PromiseCard({ title, text }: { title: string; text: string }) {
  return (
    <div className="bg-[#071008] border border-white/5 rounded-sm p-5">
      <div className="text-[11px] tracking-[0.25em] uppercase text-white/80">
        {title}
      </div>
      <p className="mt-3 text-sm text-white/60 leading-relaxed">{text}</p>
    </div>
  );
}

function FeaturedHarvest() {
  return (
    <section id="seasonal" className="bg-[#070f09]">
      <div className="mx-auto max-w-6xl px-5 py-14 md:py-16">
        <div className="flex items-end justify-between gap-6">
          <div>
            <h2 className="mt-3 text-3xl md:text-4xl font-light">
              As nossas colheitas
            </h2>
          </div>

          <a
            href="#shop"
            className="hidden md:inline-flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase text-white/70 hover:text-white"
          >
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {PRODUCTS.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ProductCard({ product }: { product: Product }) {
  return (
    <article className="group bg-[#061007] border border-white/5 rounded-sm overflow-hidden">
      <div className="relative h-72 overflow-hidden">
        <img
          src={product.imageSrc}
          alt={`Maçã ${product.name} — Frescura das Beiras`}
          className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform duration-500"
          loading="lazy"
          decoding="async"
          width={800}
          height={800}
        />
        {product.badge ? (
          <div
            className={cx(
              "absolute top-4 left-4 px-2.5 py-1 rounded-sm text-[10px] tracking-[0.25em] uppercase font-semibold",
              "bg-[#c6a86a] text-[#08110b]"
            )}
          >
            {product.badge}
          </div>
        ) : null}
      </div>

      <div className="p-5">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="text-base font-medium">{product.name}</h3>
            <p className="mt-1 text-[10px] tracking-[0.22em] uppercase text-white/55">
              {product.subtitle}
            </p>
          </div>
        </div>
      </div>
    </article>
  );
}

function Heritage() {
  return (
    <section id="sobrenos" className="bg-[#08110b]">
      <div className="mx-auto max-w-6xl px-5 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-6">
            <div className="overflow-hidden rounded-sm border border-white/5">
              <img
                src={sustainability800}
                alt="Tradição agrícola nas Beiras"
                className="w-full h-[380px] object-cover"
              />
            </div>
          </div>

          <div className="md:col-span-6">
            <p className="text-[10px] tracking-[0.35em] uppercase text-white/60">
              A nossa história
            </p>

            <h2 className="mt-4 text-3xl md:text-5xl font-light leading-[1.1]">
              Com raízes na tradição, <br />
              a pensar no futuro
            </h2>

            <p className="mt-5 text-sm text-white/65 leading-relaxed max-w-xl">
              A Frescura das Beiras nasce do respeito pela terra e pelo trabalho
              de quem a cultiva. Valorizamos métodos tradicionais, mas sempre com um olhar atento
              à inovação e à sustentabilidade.
            </p>

            <p className="mt-4 text-sm text-white/65 leading-relaxed max-w-xl">
              Cada fruta reflete esse equilíbrio: qualidade, origem conhecida e
              cuidado em todas as etapas, da quinta até à sua mesa.
            </p>

          </div>
        </div>
      </div>
    </section>
  );
}


// function Newsletter() {
//   return (
//     <section className="bg-[#070f09] border-t border-white/5">
//       <div className="mx-auto max-w-6xl px-5 py-16">
//         <div className="text-center">
//           <h2 className="text-3xl md:text-4xl font-light">Join the Harvest Club</h2>
//           <p className="mt-3 text-sm text-white/60">
//             Get weekly updates on what’s in season and exclusive discounts delivered to your inbox.
//           </p>

//           <form
//             className="mt-10 mx-auto max-w-xl flex flex-col sm:flex-row gap-3"
//             onSubmit={(e) => e.preventDefault()}
//           >
//             <label className="sr-only" htmlFor="email">
//               Your email address
//             </label>
//             <input
//               id="email"
//               type="email"
//               placeholder="Your email address"
//               className="flex-1 h-11 px-4 rounded-sm bg-[#061007] border border-white/10 text-white placeholder:text-white/35 outline-none focus:border-[#c6a86a]/60"
//             />
//             <button
//               type="submit"
//               className="h-11 px-6 rounded-sm bg-[#c6a86a] text-[#08110b] text-[11px] tracking-[0.25em] uppercase font-semibold hover:brightness-110 transition"
//             >
//               Subscribe
//             </button>
//           </form>
//         </div>
//       </div>
//     </section>
//   );
// }

function Footer() {
  return (
    <footer id="contactos" className="bg-[#061007] border-t border-white/5">
      <div className="mx-auto max-w-6xl px-5 py-14 md:py-16">
        {/* Header */}
        <div className="text-center">
          <p className="text-[10px] tracking-[0.35em] uppercase text-white/55">
            Contactos
          </p>

          <h2 className="mt-4 text-3xl md:text-4xl font-light">
            Fale connosco
          </h2>

          <div className="mx-auto mt-6 h-px w-24 bg-[#c6a86a]/80" />

          <p className="mx-auto mt-6 max-w-2xl text-sm md:text-base text-white/60 leading-relaxed">
            Estamos disponíveis para encomendas, parcerias e esclarecimentos.
            Responderemos o mais breve possível.
          </p>
        </div>

        {/* Contact grid */}
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          <ContactItem
            label="Morada"
            value="Estrada Mun., São João de Lourosa"
          />
          <ContactItem label="Telefone" value="+351 232 461 245" />
          <ContactItem label="Email" value="geral@frescuradasbeiras.pt" />
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/45">
            © {new Date().getFullYear()} Frescura das Beiras. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}

function ContactItem({ label, value }: { label: string; value: string }) {
  const isEmail = value.includes("@");
  const isPhone = value.includes("+") || /^\d/.test(value);

  const href = isEmail
    ? `mailto:${value}`
    : isPhone
      ? `tel:${value.replace(/\s+/g, "")}`
      : undefined;

  const isAddress = label.toLowerCase().includes("morada");


  return (
    <div className="bg-[#071008] border border-white/5 rounded-sm p-6 text-center">
      <div className="text-[11px] tracking-[0.25em] uppercase text-white/60">
        {label}
      </div>

      <div className="mt-4 h-px w-10 bg-[#c6a86a]/70 mx-auto" />

      {href ? (
        <a
          href={href}
          className="mt-4 block text-sm md:text-base text-white/75 hover:text-[#c6a86a] transition"
        >
          {value}
        </a>
      ) : isAddress ? (
        <address className="mt-4 not-italic text-sm md:text-base text-white/75">
          {value}
        </address>
      ) : (
        <p className="mt-4 text-sm md:text-base text-white/75">{value}</p>
      )}
    </div>
  );
}

function StoresSection({ stores }: { stores: Store[] }) {
  return (
    <section id="lojas" className="bg-[#070f09]">
      <div className="mx-auto max-w-6xl px-5 ">
        {/* Header */}
        <div className="max-w-2xl">
          <p className="text-[10px] tracking-[0.35em] uppercase text-white/60">
            Onde nos encontrar
          </p>

          <h2 className="mt-4 text-3xl md:text-5xl font-light leading-tight">
            As nossas lojas
          </h2>

          <div className="mt-6 h-px w-24 bg-[#c6a86a]/80" />

          <p className="mt-6 text-sm md:text-base text-white/65 leading-relaxed">
            Visite-nos em loja para encontrar fruta fresca da época, produtos
            selecionados e o acompanhamento de quem conhece a origem de cada
            colheita.
          </p>
        </div>

        {/* Cards */}
        <div className="mt-14 grid gap-10 md:grid-cols-2">
          {stores.map((s) => (
            <article
              key={s.city}
              className="group border border-white/5 bg-[#061007] rounded-sm overflow-hidden"
            >
              {/* Image */}
              <div className="relative h-[340px] overflow-hidden">
                <img
                  src={s.imageSrc}
                  alt={`Loja Frescura das Beiras em ${s.city}`}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                  loading="lazy"
                  decoding="async"
                  width={1200}
                  height={800}
                />

                {/* subtle overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/15 to-transparent" />
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="text-[11px] tracking-[0.25em] uppercase text-white/70">
                  {s.city}
                </div>

                <div className="mt-5 space-y-2 text-sm text-white/65 leading-relaxed">
                  <p>{s.address}</p>
                  <p>{s.hours}</p>
                  {s.phone ? <p>{s.phone}</p> : null}
                </div>

                <div className="mt-6 flex items-center gap-4">
                  <a
                    href={s.mapUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase
                               text-white/70 hover:text-[#c6a86a] transition"
                  >
                    Ver no mapa
                    <span
                      aria-hidden
                      className="transition-transform group-hover:translate-x-1"
                    >
                      →
                    </span>
                  </a>

                  <div className="h-px flex-1 bg-white/10" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

